<div id="summary-tour-container" class="grid grid-cols-1">
  <div class="self-tour-step-header">
    <div class="text-xl font-denim-semibold">YOU’RE ALL SET!</div>
  </div>
  <div>
    <div class="mb-4">Your self tour for {{model.AddressShort}} is scheduled for {{model.DateTitle}}</div>
    <div id="selftour-cal-anchor" class="mt-4"></div>
  </div>
  <div class="flex justify-end">
    <div class="w-full sm:w-1/2">
      <div class="grid grid-cols-2 col-gap-1">
        <button mat-flat-button color="accent" (click)="back()">BACK</button>
        <button mat-flat-button color="accent" (click)="finish()">FINISHED</button>
      </div>
    </div>
  </div>
</div>
